import { createContext } from 'react';
import type { TabCloseGuard } from '@/types';

/**
 * Per-tab channel provided by `TabContent` around each tool. `null` outside a
 * tab (Storybook, isolated tests), so consumers must tolerate its absence.
 */
export interface TabInstanceContextValue {
  tabId: string;
  setDirty: (dirty: boolean) => void;
  /** Registers this tab's close guard (see `TabContextValue.registerCloseGuard`); returns an unregister function. */
  registerCloseGuard?: (guard: TabCloseGuard) => () => void;
  /** Closes this tab without consulting its guard. */
  forceCloseTab?: () => void;
}

export const TabInstanceContext = createContext<TabInstanceContextValue | null>(null);
